import { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Percent } from "lucide-react";
import { CommissionTable } from "@/components/concierge/CommissionTable";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/admin/concierge/commissions`;

export const AdminCommissions = ({ headers, version }) => {
  const [data, setData] = useState(null);

  const load = useCallback(async () => {
    const res = await axios.get(API, { headers });
    setData(res.data);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => { load(); }, [load, version]);

  const toggle = async (row) => {
    if (row.paid && !window.confirm("Annuler le statut payé ?")) return;
    await axios.put(`${API}/${row.month}/paid`, {}, { headers });
    toast.success(row.paid ? "Statut annulé" : "Marqué comme payé");
    load();
  };

  return (
    <div className="bg-white rounded-xl border p-4 space-y-3" data-testid="admin-commissions">
      <h2 className="font-bold flex items-center gap-2"><Percent className="w-5 h-5 text-pink-600" />Part conciergerie (25 % clients pro)</h2>
      <CommissionTable data={data} onToggle={toggle} showSakura />
    </div>
  );
};
